{
  "community": {
    "title": "Community - MAJORITY",
    "description": "Check out the MAJORITY community, with tons of articles on saving money and building wealth in the US, plus cool events and more!",
  
    "labels": {
      "majority_community": "Majority Community",
      "all": "All",
      "popular": "Popular",
      "events": "Events",
      "event": "Event",
      "article": "Article",
      "category": "Category",
      "tags": "Tags",
      "share": "Share",
      "search_placeholder": "Type in your search term...",
      "load_more": "Load more",
      "related_articles": "Related articles",
      "related_events": "Related events",
      "related_discounts": "Related discounts",
      "where": "Where",
      "when": "When",
      "welcome_one": "Welcome one",
      "welcome_all": "Welcome all",
      "see_articles_for": "See articles for"
    },
  
    "error": {
      "no_content": "Sorry! We’re still working on adding more content to the Community."
    }
  }
}